import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/motion/reveal'
import { SectionHeading } from '@/components/site/section-heading'
import { experience } from '@/constants/about'

export const AboutExperience: FC = (): ReactNode => {
    return (
        <section
            id='experience'
            className='relative z-[2] flex w-full flex-col gap-6 bg-background px-4 py-section-sm lg:flex-row lg:items-start lg:px-6'
        >
            <div className='relative z-[1] w-full lg:sticky lg:top-24 lg:max-w-[32%] lg:flex-1'>
                <SectionHeading lead="Where I've" title="worked" />
            </div>

            <ol className='flex w-full flex-col border-t border-border lg:flex-1 lg:mt-section-sm'>
                {experience.map((item, index) => (
                    <li key={`${item.company}-${item.period}`} className='border-b border-border'>
                        <Reveal y={20} delay={index * 0.03}>
                            <article className='grid grid-cols-1 gap-5 py-8 text-foreground md:grid-cols-[minmax(0,0.9fr)_minmax(0,1fr)] md:gap-6 lg:py-10'>
                                <div className='flex flex-col gap-3'>
                                    <p className='t-italic text-left text-umber'>
                                        {item.period}
                                    </p>

                                    <h3 className='t-title text-left'>
                                        {item.role}
                                    </h3>

                                    <p className='t-body text-left'>
                                        {item.company}
                                    </p>
                                </div>

                                <ul className='flex flex-col gap-3 md:pt-1'>
                                    {item.points.map((point) => (
                                        <li key={point} className='t-body flex max-w-[560px] gap-3 text-left text-muted-foreground'>
                                            <span aria-hidden='true' className='t-meta pt-1.5 text-umber'>
                                                &rarr;
                                            </span>

                                            <span>
                                                {point}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </article>
                        </Reveal>
                    </li>
                ))}
            </ol>
        </section>
    )
}
